// 📁 src/context/GTMContext.jsx
import React, { createContext, useState, useContext } from "react";

const GTMContext = createContext();

export const GTMProvider = ({ children }) => {

  // ==========================================
  // 🔵 EXISTING STATES (unchanged)
  // ==========================================
  const [gtmPlan, setGTMPlan] = useState("");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ==========================================
  // 🔵 NEW STATES (Option A — safe additions)
  // ==========================================
  const [gtmRecordId, setGTMRecordId] = useState(null);    // unique record per idea
  const [gtmIdeaId, setGTMIdeaId] = useState(null);        // current idea's GTM
  const [autosavePending, setAutosavePending] = useState(false); // UI indicator

  return (
    <GTMContext.Provider
      value={{
        // existing
        gtmPlan,
        setGTMPlan,
        history,
        setHistory,
        loading,
        setLoading,
        error,
        setError,

        // new
        gtmRecordId,
        setGTMRecordId,
        gtmIdeaId,
        setGTMIdeaId,
        autosavePending,
        setAutosavePending,
      }}
    >
      {children}
    </GTMContext.Provider>
  );
};

export const useGTM = () => useContext(GTMContext);
